export default __webpack_public_path__ + "static/media/uberLogo.2a12c57f.svg";